import request from '../../../config/Request'

const dispatch = {
    dispatchQueryList:'/api/Dispatch/queryList',// 查询调度计划列表
    dispatchQueryDetail:'/api/Dispatch/queryDetail',// 查询调度计划详细
    dispatchEditDetail:'/api/Dispatch/editDetail',// 编辑调度计划
    dispatchDelDetail:'/api/Dispatch/delDetail',// 删除调度计划

    dispatchTacticsQueryList:'/api/DispatchTactics/queryList',// 查询调度计划策略列表
    dispatchTacticsQueryDetail:'api/DispatchTactics/queryDetail',// 查询调度计划策略详细
    dispatchTacticsEditDetail:'api/DispatchTactics/editDetail',// 编辑调度计划策略
    dispatchTacticsDelDetail:'api/DispatchTactics/delDetail',// 删除调度计划策略

    queryDispatchAlarmList:'/api/DispatchQuery/queryDispatchAlarmList',// 调度计划告警查询
    queryDispatchEventList:'/api/DispatchQuery/queryDispatchEventList',// 调度计划事件查询
    queryDispatchLoadList:'/api/DispatchQuery/queryDispatchLoadList',// 调度计划装载历史查询
    queryDispatchLocationList:'/api/DispatchQuery/queryDispatchLocationList',// 调度计划车辆轨迹查询
    queryDispatchStatusList:'/api/DispatchQuery/queryDispatchStatusList',// 调度计划设备状态变更历史查询
    queryDispatchDeviceAlarmList:'/api/DispatchQuery/queryDispatchDeviceAlarmList',// 调度计划设备告警历史查询
    queryDispatchMaintenanceList:'/api/DispatchQuery/queryDispatchMaintenanceList',// 调度计划维修记录历史查询
};
/**
 * 查询调度计划列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getDispatchList(parameter) {
    return request({
        url: dispatch.dispatchQueryList,
        data: parameter
    })
}
/**
 * 编辑调度计划
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function dispatchEditDetail(parameter) {
    return request({
        url: dispatch.dispatchEditDetail,
        data: parameter
    })
}
/**
 * 删除调度计划
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function dispatchDelDetail(parameter) {
    return request({
        url: dispatch.dispatchDelDetail,
        data: parameter
    })
}
/**
 * 查询调度计划策略列表
 * @param parameter 查询参数
 * @returns {AxiosPromise} 请求对象
 */
export function getDispatchTacticsList(parameter) {
    return request({
        url: dispatch.dispatchTacticsQueryList,
        data: parameter
    })
}
/**
 * 编辑调度计划策略
 * @param parameter 编辑参数
 * @returns {AxiosPromise} 请求对象
 */
export function dispatchTacticsEditDetail(parameter) {
    return request({
        url: dispatch.dispatchTacticsEditDetail,
        data: parameter
    })
}
/**
 * 删除调度计划策略
 * @param parameter 删除参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function dispatchTacticsDelDetail(parameter) {
    return request({
        url: dispatch.dispatchTacticsDelDetail,
        data: parameter
    })
}
/**
 * 调度计划告警查询
 * @param parameter 请求参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function queryDispatchAlarmList(parameter) {
    return request({
        url: dispatch.queryDispatchAlarmList,
        data: parameter
    })
}
/**
 * 调度计划事件查询
 * @param parameter 请求参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function queryDispatchEventList(parameter) {
    return request({
        url: dispatch.queryDispatchEventList,
        data: parameter
    })
}
/**
 * 调度计划装载历史查询
 * @param parameter 请求参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function queryDispatchLoadList(parameter) {
    return request({
        url: dispatch.queryDispatchLoadList,
        data: parameter
    })
}
/**
 * 调度计划车辆轨迹查询
 * @param parameter 请求参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function queryDispatchLocationList(parameter) {
    return request({
        url: dispatch.queryDispatchLocationList,
        data: parameter
    })
}
/**
 * 调度计划设备状态变更历史查询
 * @param parameter 请求参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function queryDispatchStatusList(parameter) {
    return request({
        url: dispatch.queryDispatchStatusList,
        data: parameter
    })
}
/**
 * 调度计划设备告警历史查询
 * @param parameter 请求参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function queryDispatchDeviceAlarmList(parameter) {
    return request({
        url: dispatch.queryDispatchDeviceAlarmList,
        data: parameter
    })
}
/**
 * 调度计划维修记录历史查询
 * @param parameter 请求参数（ID）
 * @returns {AxiosPromise} 请求对象
 */
export function queryDispatchMaintenanceList(parameter) {
    return request({
        url: dispatch.queryDispatchMaintenanceList,
        data: parameter
    })
}
